export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f90d934bbdfd09cfc287e09d64d1ebd58483d3b3a&name=fetchTypeahead!'